module.exports = __webpack_public_path__ + "img/1728544022754-Screenshot_10-10-2024_15539_web.whatsapp.com.jpeg.d4c9b8d6.webp";